

































import { Component, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { MessagingModule } from '@/store/modules/messaging';
import ConversationStatus from '@/models/Conversations/ConversationStatus';
import UpdateConversationStatusRequest from '@/models/Conversations/UpdateConversationStatusRequest';
import ConversationDto from '@/models/Conversations/ConversationDto';
import EntityType from '@/models/Shared/EntityType';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';

@Component({
    name: 'ConversationStatusEdit'
})
export default class extends GiganautVueDialog {
 
	conversationStatus = ConversationStatus;

	@Prop({required: true})
  entityType: EntityType

	@Prop({required: true})
  conversation: ConversationDto

  async setStatus(status: ConversationStatus) {
    if (this.entityType === EntityType.Worker) {
      const conversation = JSON.parse(JSON.stringify(WorkerDetailsModule.workerConversationsVM.selectedConversation));
      if (conversation.status !== status) {
        const request = new UpdateConversationStatusRequest();
        request.status = status;
        await WorkerDetailsModule.editConversationStatus(request);
      }
    } else {
      const conversation = JSON.parse(JSON.stringify(MessagingModule.selectedConversation));
      if (conversation.status !== status) {
        const request = new UpdateConversationStatusRequest();
        request.status = status;
        await MessagingModule.editConversationStatus(request);
      }
    }
  }
}
